var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

export function getTokens() {
  if (localStorage) {
    return JSON.parse(localStorage.getItem('tokens'));
  }

  return null;
}
export function setTokens(tokens) {
  if (localStorage) {
    localStorage.setItem('tokens', JSON.stringify(tokens));
  }
}
export function clearTokens() {
  if (localStorage) {
    localStorage.removeItem('tokens');
  }
}
export function updateTokens(tokens) {
  var prevTokens = getTokens();
  setTokens(_extends({}, prevTokens, tokens));
}